import type { GridApi, GridGroupNode } from '@mui/x-data-grid-pro';
import { GRID_ROOT_GROUP_ID, gridRowTreeSelector } from '@mui/x-data-grid-pro';
import type * as React from 'react';

export const getGroupNodes = (apiRef: React.RefObject<GridApi>): GridGroupNode[] => {
  const tree = gridRowTreeSelector(apiRef);
  return Object.values(tree).filter(
    (node): node is GridGroupNode => node?.type === 'group' && node.id !== GRID_ROOT_GROUP_ID,
  );
};
